export default {
    /* GET_ADDRESSES
    ---------------------------------------------------------------
    */
    GET_ADDRESSES_REQUEST: state => {
        state.addressesLoading = true
    },
    GET_ADDRESSES_SUCCESS: (state, data) => {
        state.addressesLoading = false
        state.addresses = data.results
    },
    GET_ADDRESSES_FAILURE: state => {
        state.addressesLoading = false
    },

    /* DELETE_ADDRESS
    ---------------------------------------------------------------
    */
    DELETE_ADDRESS_SUCCESS: (state, addressId) => {
        state.addresses = state.addresses.filter(address => address.id != addressId)
    },

    SET_ADDRESSES_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_ADDRESSES_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
}
